<template>
    <div>

        <MessageOverlay ref="overlay" />

        <NewDevice :display="displayNewDevice" :idoProp="this.user.orga.toString()" @cancel="displayNewDevice=false" @valid="validNewDevice"/>
        <DeleteDevice :display="displayDeleteDevice" :idoProp="this.user.orga.toString()" @cancel="displayDeleteDevice=false" @valid="validDeleteDevice" @forbidden="forbiddenDeleteDevice" />

        <v-row justify="center" justify-md="start" align="center" dense class="mt-1">
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                    v-model="sortingSelected"
                    dense
                    outlined
                    hide-details
                    :label="$vuetify.lang.t('$vuetify.utc.sortby')"
                    :items="sortingList"
                    @change="updateFilteredUTCs"
                >
                </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
                <v-select
                    v-model="statusFilterSelected"
                    dense
                    outlined
                    clearable
                    hide-details
                    :label="$vuetify.lang.t('$vuetify.utc.status')"
                    :items="statusFiltersList"
                >
                </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
                <v-select
                    v-model="rentalFilterSelected"
                    dense
                    outlined
                    clearable
                    hide-details
                    :label="$vuetify.lang.t('$vuetify.utc.rental')"
                    :items="rentalFiltersList"
                >
                </v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
                <h2 
                v-if="this.user.role == 'ADMINISTRATION'"
                class="mr-10">{{utcs.length}} / {{nbMax}}</h2>
            </v-col>
            <v-col cols="auto">
                <v-btn
                    elevation="1"
                    v-if="this.user.role == 'ADMINISTRATION'"
                    :class="['ADMINISTRATION'].indexOf(this.user.role) === -1 ? '' :'gradient-wintech mr-5'"
                    @click="newUTCNbQuery"
                >
                    <v-icon left>mdi-camera-plus</v-icon>
                    {{ $vuetify.lang.t('$vuetify.utc.addDevice') }}
                </v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn
                    elevation="1"
                    v-if="this.user.role == 'ADMINISTRATION'"
                    color="error"
                    @click="displayDeleteDevice=true"
                >
                    <v-icon left>mdi-delete</v-icon>
                    {{ $vuetify.lang.t('$vuetify.utc.deleteDevice') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                v-for="(utc, index) in fUtcs"
                :key="index"
                cols="12"
                sm="6"
                xl="4"
            >
                <UTCCard v-if="!utc.loading" :utc="utc" @click:settings="openUTC(index)"/>
                <v-skeleton-loader v-else class="mx-auto" type="card"></v-skeleton-loader>
            </v-col>
        </v-row>
        <UTCDialog
            :Vmodel="showPopUp"
            :utcInfos="utcInfos"
            @close="showPopUp=false"
            @validate="updateInfos"
            @update:file="updateFile"
        />
    </div>
</template>
<script>

import axios from 'axios';
import UTCDialog from './UTC/UTCDialog.vue';
import UTCCard from './UTC/UTCCard.vue';
import NewDevice from './UTC/NewDevice.vue';
import DeleteDevice from './UTC/DeleteDevice.vue';
import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'
import _ from 'lodash';
import { mapGetters } from 'vuex';
var cloneDeep = require('lodash.clonedeep');

export default {
    name: "UTC",
    components: {
        UTCDialog,
        UTCCard,
        NewDevice,
        DeleteDevice,
        MessageOverlay,
    },

    computed: {
        ...mapGetters({user: "StateUser"}),
        filtersSelected() {
            return [ this.statusFilterSelected, this.rentalFilterSelected ]
        },
    },
    data() {
        return {
            showPopUp: false,
            displayNewDevice: false,
            displayDeleteDevice: false,
            
            // general & navigation
             sortingList: [
                { text: this.$vuetify.lang.t("$vuetify.utc.serialnb"), value: "serialnb" },
                { text: this.$vuetify.lang.t("$vuetify.utc.denomination"), value: "denomination" },
                { text: this.$vuetify.lang.t("$vuetify.utc.distancecategory"), value: "distanceCategory" },
                { text: this.$vuetify.lang.t("$vuetify.utc.rangetype"), value: "rangeType" },
                { text: this.$vuetify.lang.t("$vuetify.utc.hardversion"), value: "hardVersion" },
                { text: this.$vuetify.lang.t("$vuetify.utc.softversion"), value: "softVersion" },
            ],

            sortingSelected: "serialnb",

            statusFiltersList: [
                { text: this.$vuetify.lang.t("$vuetify.utc.critical"), value: "critical" },
                { text: this.$vuetify.lang.t("$vuetify.utc.warning"), value: "warning" },
                { text: this.$vuetify.lang.t("$vuetify.utc.ok"), value: "ok" },
            ],
            statusFilterSelected: null,

            rentalFiltersList: [
                { text: this.$vuetify.lang.t("$vuetify.utc.rentalexpiration"), value: "expiration" }
            ],
            rentalFilterSelected: null,
            
            // Card view
            nbMax: 0,
            utcs: [],
            fUtcs: [],
            utcInfos: {},
        }
    },
    created() {
        this.getUTCs();
        
    },
    watch: {
        filtersSelected(newFilters) {
            let query = {};
            if (newFilters[0] !== null) query.status = newFilters[0];
            if (newFilters[1] !== null) query.rental = newFilters[1];
            if (!_.isEqual(query, this.$route.query)) this.$router.replace({ query: query });
            this.updateFilteredUTCs();
        },
    },
    methods: {
        async getUTCs() {
            try {
                const res = await axios.get('utcs/'+this.user.orga);
                if (res.status === 200) {
                    this.utcs = res.data[0].utcs;
                    this.nbMax = res.data[1].nbMax;
                    this.updateFiltersSelectedWithQuery();
                    for (const i in this.utcs) {
                        this.utcs[i].loading = true;
                        this.getFileBlob(i);
                    }
                }
            } catch(err) {
                console.err(err);
            }
        },

        async newUTCNbQuery() {
            if(this.utcs.length < this.nbMax){
                this.displayNewDevice = true;
            } else {
                this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.utc.newDeviceMax'), 7000)
            }
        },

        validNewDevice() {
            this.getUTCs();
            this.displayNewDevice=false
        },

        validDeleteDevice() {
            this.utcs=[];
            this.fUtcs=[];
            this.getUTCs();
            this.displayDeleteDevice=false
        },

        openUTC(index) {
            this.utcInfos = cloneDeep(this.fUtcs[index]);
            this.showPopUp = true;
        },

        updateFiltersSelectedWithQuery() {
            for (const [key, value] of Object.entries(this.$route.query)) {
                switch(key) {
                    case "status":
                        this.statusFilterSelected = value;
                        break;
                    
                    case "rental":
                        this.rentalFilterSelected = value;
                        break;
                }
            }
        },

        async updateFile(serialnb) {
            var index = this.utcs.findIndex(u => u.serialnb == serialnb);
            await this.getFileBlob(index);
            this.utcInfos.blob = this.utcs[index].blob;
            this.utcInfos.url = this.utcs[index].url;
            this.utcInfos.loading = this.utcs[index].loading;
        },
        async getFileBlob(index) {
            let utc = cloneDeep(this.utcs[index]);
            try {
                const res = await axios.get('utcs/' + utc.serialnb +'/'+ this.user.orga +'/file', { responseType: 'blob' });
                if (res.status == 200) {
                    const blob = res.data;
                    const objectUrl = URL.createObjectURL(blob);
                    utc.blob = blob;
                    utc.url = objectUrl;
                } else if (res.status == 204) {
                    utc.blob = null;
                    utc.url = null;
                }
                utc.loading = false;
                this.utcs[index] = cloneDeep(utc);
                this.updateFilteredUTCs();
            } catch(err) {
                console.error(err);
            }
        },
        dynamicSort(property) {
            return function (a, b) {
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result;
            }
        }, 
        updateInfos(e) {
            const index = this.utcs.findIndex(u => u.serialnb == e.serialnb);
            let utc = cloneDeep(this.utcs[index]);
            utc.threshold = e.threshold;
            utc.emissivity = e.emissivity;
            utc.hysteresis = e.hysteresis;
            utc.entryTimeSec = e.entryTimeSec;
            utc.exitTimeHour = e.exitTimeHour;
            utc.alarmFreqNb = e.alarmFreqNb;
            utc.alarmFreqIndex = e.alarmFreqIndex;
            utc.photoActive = e.photoActive;
            utc.photoFreqNb = e.photoFreqNb;
            utc.photoFreqIndex = e.photoFreqIndex;
            utc.alarmSoundOn = e.alarmSoundOn;
            utc.alarmFlagDisplayOn = e.alarmFlagDisplayOn;
            utc.denomination = e.denomination;
            utc.degFormat = e.degFormat;
            utc.dateFormat = e.dateFormat;
            utc.timeFormat = e.timeFormat;
            utc.lang = e.lang;
            utc.isNotificationActive=e.isNotificationActive
            utc.intrusionSoundOn = e.intrusionSoundOn;
            utc.intrusionFlagDisplayOn = e.intrusionFlagDisplayOn;
            utc.entryTimeSecIntr = e.entryTimeSecIntr;
            utc.exitTimeSecIntr = e.exitTimeSecIntr
            utc.intrusionOn = e.intrusionOn,
            utc.intrMode = e.intrMode,

            this.utcs[index] = cloneDeep(utc);
            this.utcInfos = cloneDeep(utc);
            this.updateFilteredUTCs();
        },

        updateFilteredUTCs() {
            this.fUtcs = this.utcs.filter(i => this.customFilter(i)).sort(this.dynamicSort(this.sortingSelected));
        },
        
        customFilter(item) {
            let result = true;
            if (this.statusFilterSelected !== null) {
                switch(this.statusFilterSelected) {
                    case 'critical': 
                        result &= (!item.isConnected || (item.isBattSupply && item.battLevel <= 30));
                        break;

                    case 'warning': 
                        result &= (item.isConnected && (item.isSupplyExceeds || item.isTempExceeds || item.isTempExtExceeds || (item.isBattSupply && item.battLevel > 30)));
                        break;

                    case 'ok' :
                        result &= (item.isConnected && !item.isBattSupply && !item.isSupplyExceeds && !item.isTempExceeds && !item.isTempExtExceeds);
                        break;
                }
            }
            if (this.rentalFilterSelected !== null) result &= item.isRentalExpiredOrSoon;
            return result;
        },
        forbiddenDeleteDevice(){
            this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.utc.deleteDeviceNOK'))
        }
    },
}
</script>
